
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/cases/design-system",
      function () {
        return require("private-next-pages/cases/design-system/index.tsx");
      }
    ]);
  